/** Hub catalog lifecycle: draft → review → approved or rejected (no other status values). */
export enum IHubCatalogStatus {
  Draft = "draft",
  Review = "review",
  Submitted = "submitted",
  Rejected = "rejected",
  Approved = "approved",
}
